import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

const ImageSkeleton = (props) => {
  const { width, height } = props;
  return (
    <ContentLoader viewBox={`0 0 ${width} ${height}`}>
      <rect x="0" y="0" rx="5" ry="5" width={width} height={height} />
    </ContentLoader>
  );
};

export default ImageSkeleton;

ImageSkeleton.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ImageSkeleton.defaultProps = {
  width: 300,
  height: 300,
};
